import './ui/styles.css';
import { App } from './App';
import { mountUI } from './ui/UI';
import type { QualityLevel } from './core/Quality';

const params = new URLSearchParams(location.search);
const canvas = document.getElementById('view') as HTMLCanvasElement;
const stored = (() => { try { return localStorage.getItem('bryce.quality'); } catch { return null; } })();
const mobile = matchMedia('(pointer: coarse)').matches || /Android|iPhone|iPad/i.test(navigator.userAgent);
const level = (params.get('q') ?? stored ?? (mobile ? 'low' : 'high')) as QualityLevel;
const app = new App(canvas, level);
const ui = mountUI(document.getElementById('ui') as HTMLElement, app);

declare global {
  interface Window {
    __BRYCE__: App;
    __THREE_GAME_DIAGNOSTICS__: unknown;
  }
}
window.__BRYCE__ = app;
Object.defineProperty(window, '__THREE_GAME_DIAGNOSTICS__', { get: () => app.diagnostics() });

app.load((f, label) => ui.setProgress(f, label)).then(() => {
  ui.onLoaded();
}).catch((err) => {
  console.error(err);
  ui.showError(String(err));
});

const loop = () => {
  app.frame();
  requestAnimationFrame(loop);
};
requestAnimationFrame(loop);
